import React from "react"
import { graphql } from "gatsby"

import Layout from "../../components/layout"
import SEOComponent from "../../components/seo"
import FeatureDivider from "../../components/featureDivider"
import CollectionHolder from "../../components/collectionHolder"

function createMarkup(params) {
  return {__html: params};
};

const CollectionTemplateNew = (props) => {
  const { description, descriptionHtml, title } = props.data.shopifyCollection
  const seoDescription = props.data.shopifyCollection.seo.description
  const seoTitle = props.data.shopifyCollection.seo.title

  let collectionTags = [];
  props.data.shopifyCollection.products.forEach(({ tags }) => {
    collectionTags.push(tags)
  })
  
  let collectionTagsFlat = [...new Set(collectionTags.flat(1))];

  return (
    <Layout>
      <SEOComponent
        title={seoTitle || title}
        description={ seoDescription || description}
      />
      <section className="shopify-collection section">
        <div className="container">
          <h1 className="is-size-3 is-size-4-mobile mb-3 has-text-danger is-uppercase" >{title}</h1>
          <FeatureDivider />
          <div dangerouslySetInnerHTML={createMarkup(descriptionHtml)} />
          <CollectionHolder collection={props.data.shopifyCollection} collectionTags={collectionTagsFlat}/>
        </div>
      </section>
    </Layout>
  )
}

export default CollectionTemplateNew

export const query = graphql`
  query($id: String) {
    shopifyCollection(id: { eq: $id }) {
      handle
      id
      title
      description
      descriptionHtml
      seo {
        description
        title
      }
      products {
        handle
        id
        productType
        tags
        title
        priceRangeV2 {
          minVariantPrice {
            amount
          }
        }
        images {
          altText
          gatsbyImageData(layout: CONSTRAINED, width: 512)
        }
      }
    }
  }
`